import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53b1caca")

_pushScopeId("data-v-53b1caca")
const _hoisted_1 = { class: "block m-2" }
const _hoisted_2 = {
  for: "name",
  class: "text-gray-700"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_error_message = _resolveComponent("error-message")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("label", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.label) + " (" + _toDisplayString(_ctx.maxChars - _ctx.modelValue.length) + " characters left)", 1),
      _createVNode("textarea", {
        rows: "4",
        name: _ctx.name,
        value: _ctx.modelValue,
        rules: _ctx.isRequired,
        maxlength: _ctx.maxChars,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
      }, null, 40, ["name", "value", "rules", "maxlength"]),
      _createVNode(_component_error_message, {
        class: "text-sm text-red-600",
        name: "name"
      })
    ])
  ]))
})